import React, { useState, useEffect, useRef } from 'react';
import { cn } from '@/utils/cn';
import ImageComponentV2 from '../Image/ImageComponentV2';

function SeeFullImage({ data, onView, onClose }) {
  const [openModal, setOpenModal] = useState(onView);
  const [isScreenSmall, setIsScreenSmall] = useState(false);
  const modalRef = useRef(null);

  const handleClose = () => {
    setOpenModal(false);
    setTimeout(() => {
      onClose(false);
    }, 200);
  };

  useEffect(() => {
    if (onView) {
      setTimeout(() => {
        setOpenModal(true);
        document.body.style.overflow = 'hidden';
      }, 100);
    } else {
      setOpenModal(false);
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [onView]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        handleClose();
      }
    };

    if (openModal) {
      document.addEventListener('mousedown', handleOutsideClick);
    }

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [openModal]);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const handleResize = () => {
        setIsScreenSmall(window.innerWidth < 1024);
      };
      handleResize();

      window.addEventListener('resize', handleResize);

      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }
  }, []);

  return (
    <div
      className={cn(
        'w-full h-full bg-black/90 flex justify-center items-center opacity-30 transition-all duration-100 fixed top-full left-0 right-0',
        {
          '!top-0 !opacity-100 !z-[501]': openModal,
        },
      )}
    >
      <div
        className={cn(
          'w-full h-full flex items-center justify-center  rounded-none sm:rounded-[12px] transition-all duration-[400ms]',
          {
            '!bottom-0 !opacity-100': openModal,
          },
        )}
      >
        <div
          className="mx-10 lg:mx-0 lg:min-w-[720px]  relative bg-white mt-[65px] lg:mt-[170px]"
          ref={modalRef}
        >
          <ImageComponentV2
            src={data || '/images/dummy-image.png'}
            width={720}
            height={720}
            className="w-full h-full lg:h-[500px] max-w-full object-cover rounded-none"
            alt="userImg"
          />
        </div>
      </div>
    </div>
  );
}

export default SeeFullImage;
